// scm-home-git.component.ts
import { Component, Input } from '@angular/core';
import { UiService } from '../../../core/services/core.ui.service';
import { GfTranslateService } from '../../../core/services/core.translate.service';

@Component({
  selector: 'scm-home-git',
  template: require('./scm.home.git.html')
})
export class ScmHomeGitComponent {
  @Input() scm: any;
  @Input() user: any;
  @Input() scmData: any;
  @Input() project: any;
  @Input() protocol: string;
  /** Access instructions built by the parent ScmHomeComponent. */
  @Input() scmAccessText: any;

    protected checkoutUrl = '';
    private getClipboardApi(): { writeText(text: string): Promise<void> } | undefined {
      const navigatorRef = (this.$window as Partial<Window> | undefined)?.navigator;
      if (!navigatorRef) {
        return undefined;
      }

      return (navigatorRef as Navigator & {
        clipboard?: { writeText(text: string): Promise<void> };
      }).clipboard;
    }

    ngOnInit(): void {
        this.checkoutUrl = this.getCheckoutUrl().trim();
    }

    constructor(
        private $window: Window,
        private uiService: UiService,
        private gfTranslateService: GfTranslateService,
    ) {}

    private getCheckoutUrl() {
        if (this.scm.options.useSsh) {
            let portArg = '';
            if (this.scm.options.sshPort != 22) {
                // 'git clone ssh://' + user.unixName + '@' + scmData.hostName + ':' + scm.options.sshPort + '/gitroot/' + project.unixName
                portArg = `:${ this.scm.options.sshPort }`;
            }
            // 'git clone ssh://' + user.unixName + '@' + scmData.hostName + '/gitroot/' + project.unixName
            return `git clone ssh://${ this.user.unixName }@${ this.scm.hostName }${ portArg }/gitroot/${ this.project.unixName }`;
        } else {
            // 'git clone ' + protocol + '//' + scmData.hostName + '/git/' + project.unixName
            let userName = this.user.unixName;
            if (this.scm.options.useExternalId) {
                userName = this.user.externalId;
            }
            return `git clone ${ this.protocol }//${ this.scmData.hostName }/git/${ this.project.unixName }`;
        }
    }

    copyToClipboard(txt: string) {
        const clipboard = this.getClipboardApi();
        if (clipboard) {
          clipboard.writeText(txt)
            .then(() => {
              this.uiService.message.showSuccess(
                this.gfTranslateService.translate("Copied checkout URL to clipboard")
              );
            })
            .catch(err => console.error('Clipboard write failed:', err));
        } else {
          // Fallback mechanism in case the native functionality is not available in the browser
          this.fallbackCopyToClipboard(txt);
          this.uiService.message.showSuccess(
            this.gfTranslateService.translate("Copied checkout URL to clipboard")
          );
        }
      }
      
      /**
       * Fallback method for copying to clipboard using document.execCommand('copy')
       */
      private fallbackCopyToClipboard(txt: string) {
        const textArea = document.createElement('textarea');
        textArea.value = txt;
        // Place the auxiliary element off-screen
        textArea.style.position = 'fixed';
        textArea.style.left = '-99999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
        } catch (err) {
          console.error('Fallback: unable to copy to clipboard', err);
        } finally {
          document.body.removeChild(textArea);
        }
      }
      
}
